(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-pdp-content"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeHmGalleryAutoplay = () => {
    const evidenceSection = document.querySelector('.hm-evidence3');
    const gallery = document.querySelector('product-info media-gallery');
    if (!evidenceSection || !gallery || gallery.dataset.hmAutoplayInitialized === 'true') return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnailArea = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer) return;
    gallery.dataset.hmAutoplayInitialized = 'true';
    let timer = null;
    const delay = 5200;
    const getItems = () => Array.from(gallery.querySelectorAll('[id^="Slider-Gallery"] > [data-media-id]')).filter((item) => !item.classList.contains('product__media-item--full'));
    const stop = () => { if (!timer) return; window.clearInterval(timer); timer = null; };
    const showNext = () => {
      const items = getItems(); if (items.length < 2) return;
      const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      const nextItem = items[activeIndex >= 0 ? (activeIndex + 1) % items.length : 0];
      const slider = viewer.querySelector('[id^="Slider-Gallery"]'); if (!nextItem || !slider) return;
      items.forEach((item) => item.classList.remove('is-active')); nextItem.classList.add('is-active');
      slider.scrollTo({ left: nextItem.offsetLeft, behavior: 'smooth' });
      if (thumbnailArea) {
        thumbnailArea.querySelectorAll('[data-target] button').forEach((button) => button.removeAttribute('aria-current'));
        const activeThumb = thumbnailArea.querySelector(`[data-target="${nextItem.dataset.mediaId}"] button`);
        if (activeThumb) activeThumb.setAttribute('aria-current', 'true');
      }
    };
    const play = () => { stop(); if (document.hidden || getItems().length < 2) return; timer = window.setInterval(showNext, delay); };
    viewer.addEventListener('mouseenter', stop); viewer.addEventListener('mouseleave', play); viewer.addEventListener('focusin', stop); viewer.addEventListener('focusout', play);
    thumbnailArea?.addEventListener('click', () => { stop(); window.setTimeout(play, 3500); });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : play());
    reducedMotion.addEventListener('change', () => reducedMotion.matches ? stop() : play()); play();
  };
  const start = () => customElements.whenDefined('media-gallery').then(initializeHmGalleryAutoplay);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hm-pdp-evidence-v3"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeHmGalleryAutoplay = () => {
    const evidenceSection = document.querySelector('.hm-evidence3');
    const gallery = document.querySelector('product-info media-gallery');
    if (!evidenceSection || !gallery || gallery.dataset.hmAutoplayInitialized === 'true') return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnailArea = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!viewer) return;
    gallery.dataset.hmAutoplayInitialized = 'true';
    let timer = null;
    const delay = 5200;
    const getItems = () => Array.from(gallery.querySelectorAll('[id^="Slider-Gallery"] > [data-media-id]')).filter((item) => !item.classList.contains('product__media-item--full'));
    const stop = () => { if (!timer) return; window.clearInterval(timer); timer = null; };
    const showNext = () => {
      const items = getItems(); if (items.length < 2) return;
      const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      const nextItem = items[activeIndex >= 0 ? (activeIndex + 1) % items.length : 0];
      const slider = viewer.querySelector('[id^="Slider-Gallery"]'); if (!nextItem || !slider) return;
      items.forEach((item) => item.classList.remove('is-active')); nextItem.classList.add('is-active');
      slider.scrollTo({ left: nextItem.offsetLeft, behavior: 'smooth' });
      if (thumbnailArea) {
        thumbnailArea.querySelectorAll('[data-target] button').forEach((button) => button.removeAttribute('aria-current'));
        const activeThumb = thumbnailArea.querySelector(`[data-target="${nextItem.dataset.mediaId}"] button`);
        if (activeThumb) activeThumb.setAttribute('aria-current', 'true');
      }
    };
    const play = () => { stop(); if (document.hidden || getItems().length < 2) return; timer = window.setInterval(showNext, delay); };
    viewer.addEventListener('mouseenter', stop); viewer.addEventListener('mouseleave', play); viewer.addEventListener('focusin', stop); viewer.addEventListener('focusout', play);
    thumbnailArea?.addEventListener('click', () => { stop(); window.setTimeout(play, 3500); });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : play());
    reducedMotion.addEventListener('change', () => reducedMotion.matches ? stop() : play()); play();
  };
  const start = () => customElements.whenDefined('media-gallery').then(initializeHmGalleryAutoplay);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();

  } catch(e) { console.error(e); }
})();
})();
